import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles(() => ({
  LogoContainer: {
    display: 'flex',
    alignItems: 'center',
    height: 120,
    '@media (max-width: 1181px)': {
      height: 74,
    },
  },
  imageContent: {},
  logoImg: {
    width: 90,
  },
  LogoTitle: {
    color: variables.black50,
    fontSize: 14,
    fontWeight: 500,
  },
}));
